export function toggle() {
    document.querySelectorAll('[data-toggle-target]').forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();

            const name = toggle.dataset.toggleTarget;
            const singular = toggle.dataset.singular ? toggle.dataset.singular === 'true' : false;
            const group = toggle.dataset.group ? toggle.dataset.group : null;
            const settings = toggle.dataset.settings ? JSON.parse(toggle.dataset.settings) : {};
            const clickAway = settings.clickAway ? settings.clickAway : false;

            if (singular) {
                if (group) {
                    document.querySelectorAll(`[data-toggle-target][data-group="${group}"]`).forEach(target => {
                        target.classList.remove('active');
                    });

                    document.querySelectorAll(`[data-toggle-item][data-group="${group}"]`).forEach(target => {
                        const slide = target.dataset.slide ? target.dataset.slide : null;

                        if (slide) {
                            target.style.maxHeight = target.scrollHeight + "px";
                            target.style.maxHeight = null;
                        }

                        target.classList.remove('active');
                    });
                }

                document.querySelectorAll(`[data-toggle-target="${name}"]`).forEach(toggle => {
                    toggle.classList.add('active');
                });

                document.querySelectorAll(`[data-toggle-item="${name}"]`).forEach(target => {
                    const slide = target.dataset.slide ? target.dataset.slide : null;

                    if (slide) {
                        target.style.maxHeight = target.scrollHeight + "px";
                    }

                    target.classList.add('active');
                });
            } else {
                document.querySelectorAll(`[data-toggle-target="${name}"]`).forEach(toggle => {
                    toggle.classList.toggle('active');
                });

                document.querySelectorAll(`[data-toggle-item="${name}"]`).forEach(target => {
                    target.classList.toggle('active');
                });
            }

            if (clickAway) {
                document.addEventListener('click', (e) => {
                    if (!toggle.contains(e.target)) {
                        document.querySelectorAll(`[data-toggle-target="${name}"]`).forEach(toggle => {
                            toggle.classList.remove('active');
                        });

                        document.querySelectorAll(`[data-toggle-item="${name}"]`).forEach(target => {
                            target.classList.remove('active');
                        });
                    }
                });
            }
        });
    });
}
